import React from 'react'
import {
  Grid, Paper,  Typography } from '@mui/material'

/**
 * Reusable card component for public pages
 * Provides consistent styling and responsive layout
 */
const PublicPageCard = ({
  children,
  elevation = 3,
  padding = '20px',
  backgroundColor = '#f5f5f5',
  marginBottom = '20px',
  direction = { xs: 'column', md: 'row' },
  spacing = 4,
  alignItems = 'center',
  ...props
}) => {
  return (
    <Paper
      elevation={elevation}
      style={{
        padding,
        backgroundColor,
        marginBottom}}
      {...props}
    >
      <Grid
        container
        spacing={spacing}
        style={{ padding: '20px' }}
        direction={direction}
        sx={{
          alignItems: alignItems
        }}
      >
        {children}
      </Grid>
    </Paper>
  );
}

export default PublicPageCard
